import { mutate } from 'swr';
// logic
import '../../ui/emergencyPopup.css';
import ticketService from '../../ticket-service';
// components
import CancelTicketModal from './cancelTicketModal';
import { Modal } from 'react-async-popup';
import { useTranslation } from 'react-i18next';

const useCancelTicketModal = (ticket) => {
  const cancelTicketModalProps = { ticket };
  const { t } = useTranslation(['Emergencies']);

  const cancelTicket = async () => {
    const { show } = await Modal.new({
      content: (
        <CancelTicketModal
          t={t}
          cancelTicketModalProps={cancelTicketModalProps}
        />
      ),
      footer: null,
    });
    const result = await show();
    return result;
  };

  const openModalCancelTicket = async () => {
    const result = await cancelTicket();
    if (result) {
      const feedBackDTO = {
        reasons: [
          {
            category: result.reason,
          },
        ],
      };
      if (result.text.trim().length > 0) feedBackDTO.text = result.text;
      await ticketService.callBackend.cancelTicket({
        id: ticket.id,
        feedBackDTO,
      });
      // we are mutating the tickets cache so it will reload automatically
      mutate((key) => {
        return typeof key === 'string' && key.startsWith('tickets');
      });
    }
  };

  return {
    openModalCancelTicket,
  };
};

export default useCancelTicketModal;
